import { BlueBirdTheme, Loading, Typography } from "@kitbird/core";
import { ReactNode } from "react";
import styled from "styled-components";
import Lottie from "lottie-react";

import * as animationData from "../../assets/lotties/frame-loading.json";

interface PageLoadingI {
  description?: string | number | ReactNode,
  progressConfig?: {
    total: number,
    finished: number,
  },
}
const PageLoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: #0000007f;
  width: 100%;
  height: 100%;
  display: flex;
  > div {
    margin: auto;
  }
`;

const PageLoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoadingLottie = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    style: {
      width: 180,
      height: 180,
    },
  };

  return (
    <Lottie {...defaultOptions} />
  );
};

const PageLoading = ({ progressConfig, description }: PageLoadingI) => (
  <PageLoadingWrapper>
    <PageLoadingContent>
      <LoadingLottie />
      <Typography
        level={4}
        color={BlueBirdTheme.colors.white}
        fontWeight="medium"
      >
        {progressConfig
          && `${progressConfig.finished} / ${progressConfig.total}`
        }
        <br />
        {description}
      </Typography>
    </PageLoadingContent>

  </PageLoadingWrapper>
);

export default PageLoading;
